module.exports = __webpack_public_path__ + "static/rick-010-745acb478f321882b54d36073af000ef.jpg";